// extracted by mini-css-extract-plugin
export var editor = "_27-0";
export var flowSidebar = "_6o-2";